var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    var initializeBlock = function ($block) {
        // switch buttons
        jQuery('.block-range-selector__hbuttons .btn').on('click', function () {
            if (jQuery(this).hasClass('c-button--active')) {
                return;
            }
        
            // Finds the closest parent with an ID attribute
            var parentContainer = jQuery(this).closest('[id]'); 
        
            // Check if the parent container has an ID attribute
            if (parentContainer.length > 0) {
                var parentId = parentContainer.attr('id');
                console.log(parentId);
        
                // Use the parent container to narrow down the scope
                var selectedTab = jQuery(this).attr('data-to-open');
                parentContainer.find('.c-button--active').removeClass('c-button--active');
                jQuery(this).addClass('c-button--active');
                parentContainer.find('.tab-content--active').removeClass('tab-content--active');
                parentContainer.find('.tab-content[data-tab="' + selectedTab + '"]').addClass('tab-content--active');
            } 
        });
        // switch dropdown
        jQuery('.block-range-selector__select .select2-init').change(function () {
            let val = jQuery(this).val();
            jQuery('.block-range-selector__hbuttons .btn[data-to-open="' + val + '"]').click();
        });

        // swiper
        const swiper = new Swiper('.block-range-selector .swiper-container', {
            spaceBetween: 20,
            slidesPerView: 1.5,
            autoHeight: false,
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
        });
    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=range-selector', initializeBlock);
    }
});


// swiper for mobile only
// https://codepen.io/EFX/pen/xxKOwLw
// https://codepen.io/aaronkahlhamer/pen/GveaXP

// var swiper = Swiper;
// var init = false;
//
// function swiperMode() {
//     let mobile = window.matchMedia('(min-width: 0px) and (max-width: 991px)');
//     let desktop = window.matchMedia('(min-width: 768px)');
//
//     const enableSwiper = function () {
//
//     }
//
//     Enable (for mobile)
//     if (mobile.matches) {
//         if (!init) {
//             init = true;
//             enableSwiper();
//         }
//     }
//     Disable (for desktop)
//     else if (desktop.matches) {
//         // console.log(swiper);
//         // swiper.destroy();
//         init = false;
//     }
// }
//
// $(window).on('load', function () {
//     swiperMode();
// });
// $(window).on('resize', function () {
//     swiperMode();
// });
